export enum DateFormat {
  DATE = 'MMM DD, YYYY',
  TIME = 'hh:mm A',
}
